import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const TallyContent = () => {
  useEffect(() => {
    // Load Tally script if not already loaded
    if (window.Tally) {
      window.Tally.loadEmbeds();
    }
  }, []);

  return (
    <iframe
      data-tally-src="https://tally.so/embed/wM9zA0?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
      loading="lazy"
      width="100%"
      height="276"
      frameBorder="0"
      marginHeight="0"
      marginWidth="0"
      title="Rebel contact form - join the waitlist"
      aria-label="Contact form for joining the Rebel waitlist"
    ></iframe>
  );
};

const Contact = () => {
  return (
    <section id="contact" className="section-padding">
      <div className="container-max px-4">
        <div className="w-full max-w-4xl mx-auto text-center mb-12">
          <p className="text-xs font-bold tracking-widest text-rebel-coral uppercase mb-4 font-sans" style={{maxWidth: 'none'}}>
            GET IN TOUCH
          </p>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-semibold mb-8 text-rebel-dark leading-tight">
            Say hello!
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 leading-relaxed w-full" style={{maxWidth: 'none'}}>
            Get in touch to join the waiting list for Rebel sensors
          </p>
        </div>

        {/* Tally Form and Who We're Looking For - Side by Side */}
        <div className="mb-20 grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {/* Tally Form */}
          <div>
            <TallyContent />
          </div>

          {/* Who we're looking for */}
          <div>
            <div className="game-card p-10">
              <h4 className="text-2xl font-bold text-rebel-dark mb-8 text-center">Who we're looking for</h4>
              <div className="space-y-4">
                <div className="flex items-start space-x-4">
                  <span className="text-rebel-coral font-bold mt-1">→</span>
                  <span className="text-gray-600">Homeowners looking to upgrade heating systems</span>
                </div>
                <div className="flex items-start space-x-4">
                  <span className="text-rebel-coral font-bold mt-1">→</span>
                  <span className="text-gray-600">Heating engineers and installers</span>
                </div>
                <div className="flex items-start space-x-4">
                  <span className="text-rebel-coral font-bold mt-1">→</span>
                  <span className="text-gray-600">Property developers and managers</span>
                </div>
                <div className="flex items-start space-x-4">
                  <span className="text-rebel-coral font-bold mt-1">→</span>
                  <span className="text-gray-600">Investors and partners</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-20 pt-8 text-center border-t border-gray-200 w-full max-w-4xl mx-auto">
          <p className="text-gray-500 text-sm w-full" style={{maxWidth: 'none'}}>
            © 2025 Rebel. Join the heating rebellion.
          </p>
          <p className="text-gray-400 text-xs mt-2 w-full" style={{maxWidth: 'none'}}>
            Company number 15664690
          </p>
          <p className="text-gray-400 text-xs mt-2 w-full" style={{maxWidth: 'none'}}>
            <Link to="/privacy" className="hover:text-rebel-coral transition-colors">Privacy Policy</Link>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contact;